import React from "react";

export default function Marquee({ items, testId }) {
  const row = [...items, ...items];
  return (
    <div
      data-testid={testId}
      className="relative w-full overflow-hidden border-y border-white/5 py-5 bg-[#060608]"
    >
      <div className="flex whitespace-nowrap animate-marquee will-change-transform">
        {row.map((t, i) => (
          <span key={i} className="mx-8 flex items-center gap-8">
            <span className="font-display text-lg md:text-2xl font-semibold tracking-tight text-white/25">
              {t}
            </span>
            <span className="text-primary font-mono-tech text-xs">///</span>
          </span>
        ))}
      </div>
    </div>
  );
}
